<div class="w-full px-4">
  <div class="grid grid-cols-4 gap-4">
    <!-- User Details Form -->
    <div class="flex flex-col">
      <h4 class="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-3">User Details</h4>
      <div class="rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 dark:bg-gray-800 p-3">
        <div [formGroup]="userForm" class="space-y-3">
          <div class="form-group">
            <input id="id" formControlName="id" *ngIf="false" />
            <label for="userName"
              class="block text-xs font-medium text-gray-900 dark:text-gray-200 mb-1">UserName</label>
            <kendo-textbox id="userName" formControlName="userName" class="w-full text-sm"
              style="background-color: white !important; color: #1f2937 !important;"
              placeholder="userName"></kendo-textbox>
            <gd-validation-message label="UserName" [showMinLength]="userName?.hasError('minLength')"
              [showMaxLength]="userName?.hasError('maxLength')" minLength="3" maxLength="20"></gd-validation-message>
          </div>
          <div class="form-group">
            <label for="email" class="block text-xs font-medium text-gray-900 dark:text-gray-200 mb-1">Email</label>
            <kendo-textbox id="email" formControlName="email" class="w-full text-sm"
              style="background-color: white !important; color: #1f2937 !important;"
              placeholder="Email"></kendo-textbox>
            <gd-validation-message label="Email" [showMinLength]="email?.hasError('minLength')"
              [showMaxLength]="email?.hasError('maxLength')" minLength="3" maxLength="20"></gd-validation-message>
          </div>
          <div class="form-group">
            <label for="firstName" class="block text-xs font-medium text-gray-900 dark:text-gray-200 mb-1">First
              Name</label>
            <kendo-textbox id="firstName" formControlName="firstName" class="w-full text-sm"
              style="background-color: white !important; color: #1f2937 !important;"
              placeholder="First Name"></kendo-textbox>
            <gd-validation-message label="First Name" [showMinLength]="firstName?.hasError('minLength')"
              [showMaxLength]="firstName?.hasError('maxLength')" minLength="3" maxLength="20"></gd-validation-message>
          </div>
          <div class="form-group">
            <label for="lastName" class="block text-xs font-medium text-gray-900 dark:text-gray-200 mb-1">Last
              Name</label>
            <kendo-textbox id="lastName" formControlName="lastName" class="w-full text-sm"
              style="background-color: white !important; color: #1f2937 !important;"
              placeholder="Last Name"></kendo-textbox>
            <gd-validation-message label="Last Name" [showMinLength]="lastName?.hasError('minLength')"
              [showMaxLength]="lastName?.hasError('maxLength')" minLength="3" maxLength="20"></gd-validation-message>
          </div>
          <div class="form-group">
            <label for="phoneNumber" class="block text-xs font-medium text-gray-900 dark:text-gray-200 mb-1">Phone
              Number</label>
            <kendo-maskedtextbox id="phoneNumber" formControlName="phoneNumber" class="w-full text-sm"
              style="background-color: white !important; color: #1f2937 !important;"
              [mask]="phoneMask" [promptPlaceholder]="' '"></kendo-maskedtextbox>
            <gd-validation-message label="Phone Number" [showMinLength]="phoneNumber?.hasError('minLength')"
              [showMaxLength]="phoneNumber?.hasError('maxLength')" minLength="3" maxLength="20">
            </gd-validation-message>
          </div>
          <div class="form-group">
            <div class="flex items-center">
              <label class="inline-flex items-center">
                <input type="checkbox" id="lockoutEnabled" formControlName="isApprove" (click)="toggleapprove()"
                  class="form-checkbox h-4 w-4 text-blue-550 rounded focus:ring-blue-500 dark:focus:ring-blue-550 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-550" />
                <span class="ml-2 text-xs font-medium text-gray-900 dark:text-gray-200">{{ buttonText }}</span>
              </label>
            </div>
          </div>
          <div class="form-group">
          </div>
        </div>
      </div>
    </div>

    <!-- Roles Grid -->
    <div class="flex flex-col">
      <h4 class="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-3">User Roles</h4>
      <div class="rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 dark:bg-gray-800 p-3">
        <kendo-grid [data]="getrolelist" [pageable]="false" [scrollable]="false"
          [selectable]="{ enabled: true, mode: 'multiple', checkboxOnly: true }" kendoGridSelectBy="id"
          [rowClass]="rowClassRoles"
          [(selectedKeys)]="mySelectionRoleTypes" (selectedKeysChange)="onSelectedKeysChangeRoles($event)">
          <kendo-grid-checkbox-column>
            <ng-template kendoGridHeaderTemplate>
              <input id="selectAllCheckboxId" type="checkbox" kendoCheckBox kendoGridSelectAllCheckbox
                [state]="selectAllState" [disabled]="repReadOnly" (selectAllChange)="onSelectAllChange($event)" />
            </ng-template>
          </kendo-grid-checkbox-column>
          <kendo-grid-column field="name" title="Role Name" disabled="true"></kendo-grid-column>
        </kendo-grid>
      </div>
    </div>

    <!-- Product Types Grid -->
    <div class="flex flex-col">
      <h4 class="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-3">Product Types</h4>
      <div class="rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 dark:bg-gray-800 p-3">
        <kendo-grid [data]="productTypelist" [pageable]="false" [scrollable]="false"
          [selectable]="repReadOnly ? { enabled: false } : { enabled: true, mode: 'multiple', checkboxOnly: true }"
          [ngClass]="{ 'grid-readonly': repReadOnly }" kendoGridSelectBy="productTypeId"
          [(selectedKeys)]="mySelection" (selectedKeysChange)="onSelectedKeysChangeProducts($event)">
          <kendo-grid-checkbox-column [width]="40"></kendo-grid-checkbox-column>
          <kendo-grid-column field="productTypeDesc2" title="Product Type"></kendo-grid-column>
        </kendo-grid>
      </div>
    </div>

    <!-- Email Types Grid -->
    <div class="flex flex-col">
      <h4 class="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-3">Email Types</h4>
      <div class="rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 dark:bg-gray-800 p-3">
        <kendo-grid [data]="emailTypelist" [pageable]="false" [scrollable]="false"
          [selectable]="repReadOnly ? { enabled: false } : { enabled: true, mode: 'multiple', checkboxOnly: true }"
          [ngClass]="{ 'grid-readonly': repReadOnly }" kendoGridSelectBy="emailTypeId"
          [(selectedKeys)]="mySelectionemailTypes" (selectedKeysChange)="onSelectedKeysChangeEmails($event)">
          <kendo-grid-checkbox-column [width]="40"></kendo-grid-checkbox-column>
          <kendo-grid-column field="displayName" title="Email Type"></kendo-grid-column>
        </kendo-grid>
      </div>
    </div>
  </div>

  <!-- Submit Button -->
  <div class="mt-6 flex justify-center">
    <button (click)="onSubmit()"
      class="bg-blue-500 hover:bg-blue-700 dark:bg-blue-600 dark:hover:bg-blue-700 text-white px-8 py-3 rounded-md font-medium transition-colors border border-blue-500 hover:border-blue-700 dark:border-blue-600 dark:hover:border-blue-700">
      Submit
    </button>
  </div>
</div>